import { Backdrop, CircularProgress, Typography, Box } from "@mui/material";
import Logo from "./../assets/png/nopala_logo.png";

const CustomBackdrop = ({ open, message = null }) => {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.modal + 1,
        backgroundColor: "rgba(0, 0, 0, 0.85)",
        backdropFilter: "blur(10px)",
        // zIndex: -1,
      }}
      open={open}
      transitionDuration={500}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          gap: 4,
        }}
      >
        <Box sx={{ position: "relative" }}>
            <CircularProgress size={180} thickness={4} sx={{ color: "#fff" }}/>
            <Box
                component="img"
                src={Logo}
                alt="NOPALA LOGO"
                sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 64,
                height: 64,
                objectFit: "contain",
                filter: 'drop-shadow(0 0 8px rgba(255, 255, 255, 0.8))'
                }}
            />
        </Box>
        {message && (
          <Typography
            variant="h6"
            sx={{
              color: "#fff",
              fontWeight: 500,
              textAlign: "center",
              maxWidth: 300,
            }}
          >
            {message}
          </Typography>
        )}
      </Box>
    </Backdrop>
  );
};

export default CustomBackdrop;